module.exports = __webpack_public_path__ + "img/thumbnail_AfricanWildDog_f_normal.de9c89a2.png";